import {
  JobList,
  JoinCapacity,
  MasQuitReasonList,
  SexFlug,
  UseOrNot,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepperData = ["内容入力・確認", "加入登録手続き確認", "機構へ提出"];

const monthMappings = {
  apr: "4",
  may: "5",
  jun: "6",
  jul: "7",
  aug: "8",
  sep: "9",
  oct: "10",
  nov: "11",
  dec: "12",
  jan: "1",
  feb: "2",
  mar: "3",
};

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "引継ぎコード",
    keyword: "transferCd",
    radioPropsList: TkGetCodeList(UseOrNot),
    type: "transferCodeText",
    isShowInput: "none",
    helpicon: true,
    helpText: (
      <>
        別の共済契約者から転職して加入する職員については当該職員に引継ぎコードの有無を確認のうえ、入力してください。
        <br />
        引継ぎコードを入力しない場合は、前の勤務先での被共済職員期間（勤務期間）を引継ぐことができず、退職手当金を正しく計算することができなくなりますので、必ず入力をしてください。
        <br />
      </>
    ),
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "施設名",
    keyword: "facilityNameList",
    type: "selectForm",
    requiredIcon: true,
    selectPropsList: [
      {
        value: "0",
        label: "",
      },
    ],
    helpicon: true,
    helpText: (
      <>
        職員が加入する施設または事業を選択してください。２つの施設また事業を兼務する職員については
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫兼務職員の取り扱いについて.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        （別紙PDFへのリンク）をご確認ください。
        <br />
      </>
    ),
  },
  {
    title: "氏名（ｶﾅ）",
    keyword: "staffNameKana",
    type: "name",
    useFurigana: true,
    convertToHalfwidth: true,
    hafWidth: true,
    helpicon: true,
    helpText: "加入する職員の氏名（フリガナ）を入力してください。",
  },
  {
    title: "氏名",
    keyword: "staffNameKanji",
    type: "name",
    requiredIcon: true,
    helpicon: true,
    onlyFullWidth: true,
    helpText: (
      <>
        加入する職員の氏名を入力してください。
        <br />
        外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されない恐れがありますので、当該文字は使用せず、常用漢字を用いて入力をお願いします。
        <br />
        なお、外国人については、フリガナ、漢字欄ともに「カタカナ」で入力をしてください。
        <br />
      </>
    ),
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "date",
    maxDate: new Date(),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "加入する職員の生年月日を入力してください。または「カレンダーボタン」にて選択してください。",
  },
  {
    title: "性別",
    keyword: "sex",
    type: "radio",
    requiredIcon: true,
    radioPropsList: TkGetCodeList(SexFlug),
    helpicon: true,
    helpText: "加入する職員の性別を選択してください。",
  },
  {
    title: "加入年月日",
    keyword: "joinDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        職員の加入年月日を入力してください。加入資格（ア～ウ）により加入年月日が異なります。
        <br />
        詳しくは
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        （別紙ＰＤＦへのリンク）をご確認ください。
        <br />
        ※入力日によっては、登録できない場合があります。
        <br />
      </>
    ),
  },
  {
    title: "加入資格",
    keyword: "joinCapacity",
    type: "radio",
    requiredIcon: true,
    radioPropsList: TkGetCodeList(JoinCapacity),
    helpicon: true,
    helpText: (
      <>
        加入要件については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        （別紙PDFへのリンク）をご確認ください。
        <br />
      </>
    ),
  },
  {
    title: "職種",
    keyword: "jobCd",
    type: "selectForm",
    requiredIcon: true,
    selectPropsList: TkGetCodeList(JobList),
    helpicon: true,
    helpText: (
      <>
        加入する職員の職種を選択してください。予め指定されている職種の中から一番近いものを選択してください。詳しくは、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫職種について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
        <br />
      </>
    ),
  },
  {
    title: "俸給表の額",
    keyword: "salaryTableAmt",
    requiredIcon: true,
    type: "amount",
    inputProps: { maxLength: 9 },
    helpicon: true,
    helpText: (
      <>
        共済契約者が給与規程で定める本俸月額を入力してください。ただし、給与規程で本俸が定められていない職員は、雇用契約書で定める労働条件をもとに計算した額となります。日給・時給の場合の記載方法は、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給表の額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        （別紙PDFへのリンク）をご確認ください。
        <br />
        【注意点】実際の支給された額を記載するのではなく、給与規程や雇用契約書等に定められた額を記載してください。
        <br />
      </>
    ),
  },
  {
    title: "俸給の調整額",
    keyword: "salaryAdjustmentAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    helpicon: true,
    helpText: (
      <>
        「俸給の調整額」対象手当として当機構が認めた手当があれば、その合計金額を入力してください。登録されている手当以外の金額は計上することができません。未登録の場合は登録申請が必要です。
        <br />
        ※俸給の調整額については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給の調整額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        （別紙PDFへのリンク）をご確認ください。
        <br />
      </>
    ),
  },
  {
    title: "被共済職員であったことの有無",
    keyword: "masPastFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    helpicon: true,
    helpText: "過去に被共済職員であったことの有無を選択してください。",
  },
  {
    title: "被共済職員でなくなった理由",
    keyword: "masQuitReason",
    type: "selectForm",
    selectPropsList: TkGetCodeList(MasQuitReasonList),
    helpicon: true,
    helpText:
      "過去に被共済職員であったことがある場合は、被共済職員でなくなった理由を選択してください。",
  },
  {
    title: "被共済職員でなくなった年月日",
    keyword: "masQuitDate",
    type: "date",
    maxDate: new Date(),
    helpicon: true,
    helpText:
      "過去に被共済職員であったことがある場合は、被共済職員でなくなった年月日を直接入力していただくか、「カレンダーボタン」にて選択してください。",
  },
  {
    title: "前共済契約者名",
    keyword: "bContractName",
    type: "label",
    inputProps: { minLength: 1, maxLength: 60 },
    showLine: false,
  },
  {
    title: "前共済契約者番号",
    keyword: "bContractNo",
    type: "label",
    inputProps: { minLength: 1, maxLength: 6 },
    showLine: false,
  },
  {
    title: "前職員番号",
    keyword: "bStaffNo",
    type: "label",
    inputProps: { minLength: 1, maxLength: 5 },
    showLine: false,
  },
  {
    keyword: "employmentStatus",
    type: "lineTitle",
    lineTitle: "従業状況",
    showLine: false,
  },
  {
    keyword: "notBeMonth",
    type: "node",
    node: null,
    showLine: false,
  },
];

const schema = {
  facilityNameList: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  staffNameKana: {
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  staffNameKanji: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  birthday: { required: TkPropertyMessageGet("TKMSG_SCR0043E") },
  sex: { required: TkPropertyMessageGet("TKMSG_SCR0043E") },
  joinDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  joinCapacity: { required: TkPropertyMessageGet("TKMSG_SCR0043E") },
  jobList: { required: TkPropertyMessageGet("TKMSG_SCR0043E") },
  salaryTableAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    min: {
      value: 0,
      message: TkPropertyMessageGet("TKMSG_SCR0047E", "0"),
    },
    max: {
      value: 999999999,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999999999"),
    },
  },
  jobCd: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  salaryAdjustmentAmt: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    min: {
      value: 0,
      message: TkPropertyMessageGet("TKMSG_SCR0047E", "0"),
    },
    max: {
      value: 999999999,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999999999"),
    },
  },
  bContractName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 60,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "60"),
    },
  },
  bContractNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "6"),
    },
  },
  bStaffNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 5,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "5"),
    },
  },
};

export { stepperData, monthMappings, fakeTableList, schema };
